import { render } from "./DropList.vue?vue&type=template&id=6fbe9892&scoped=true"
import script from "./DropList.vue?vue&type=script&lang=js"
export * from "./DropList.vue?vue&type=script&lang=js"

import "./DropList.vue?vue&type=style&index=0&id=6fbe9892&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fbe9892"]])

export default __exports__